import { render, staticRenderFns } from "./FolderStyle.vue?vue&type=template&id=493a8198&scoped=true&"
import script from "./FolderStyle.vue?vue&type=script&lang=ts&"
export * from "./FolderStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a8198",
  null
  
)

export default component.exports